// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress__3iHrv","bordered":"bordered__lWFwD"};